import { cn } from '@/utlis/cn'

export function Badge({
    children,
    className,
    noAbsolute,
}: React.PropsWithChildren<{ className?: string; noAbsolute?: boolean }>) {
    return (
        <div
            className={cn(
                !noAbsolute && 'absolute top-1 right-1',
                'flex items-center justify-center pointer-events-none w-[14px] h-[14px] text-black text-[10px] font-medium bg-[#E7CA2D] rounded-full',
                className
            )}
        >
            {children}
        </div>
    )
}
